var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$settings.admin)?_c('div',{staticClass:"e-lite"},[_c('div',{staticClass:"t-device",attrs:{"id":"e-preview"}}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-form"},[_c('div',{attrs:{"id":"e-inputs"}}),_c('div',{attrs:{"id":"e-export"}})])
}]

export { render, staticRenderFns }